export default {
    PROPERTIES: "Свойства",
    ATTRIBUTES: "Атрибуты",
    METHODS: "Методы",
    SCRIPTS: "Скрипты",
    MORE_THAN_ONE_EDGE_SELECTED: "Выбрано более одной связи"
};
